import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CustomRouterLinkDirective} from "./custom-router-link.directive";
import {VarDirective} from "./var.directive";
import {RouterModule} from "@angular/router";
import {NgxCurrencyDirective} from "ngx-currency";
import {TemplateDirective} from "./template.directive";
import {ResizeDirective} from "./resize.directive";



@NgModule({
  declarations: [CustomRouterLinkDirective, VarDirective, TemplateDirective, ResizeDirective],
  imports: [
    CommonModule,
      RouterModule
  ],
  exports: [CustomRouterLinkDirective, VarDirective, TemplateDirective, ResizeDirective]
})
export class DirectivesModule { }
